import React from 'react';

import { AutoComplete, Form, Input } from 'antd';

import { useField } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface ISelectOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

type AutoCompleteFormFieldProps = FieldProps & {
  label?: string;
  options: ISelectOption[];
  loading?: boolean;
  helperText?: React.ReactNode;
  placeholder?: string;
  isLoading?: boolean;
  value?: ISelectOption;
  disabled?: boolean;
};

export const AutoCompleteFormField = ({
  field,
  label,
  form,
  helperText: helperTextProp,
  isLoading,
  disabled,
  ...props
}: AutoCompleteFormFieldProps) => {
  const [, meta] = useField(field.name);
  const isError = meta.touched && !!meta.error;
  const helperText = isError ? meta.error : helperTextProp;

  const handleChange = React.useCallback(
    (value: any, option: any) => {
      form.setFieldValue(field.name, option);
    },
    [field, form]
  );

  const antdOptions = props.options?.map(opt => ({
    value: String(opt.value),
    label: opt.label
  }));

  return (
    <Hint inputName={field.name}>
      <Form.Item className='mb-0 w-full' label={label} help={helperText} validateStatus={isError ? 'error' : undefined}>
        <AutoComplete
          options={antdOptions}
          value={field.value?.label || ''}
          onChange={handleChange}
          className='w-full'
          disabled={isLoading || disabled}
          filterOption={(inputValue, option) =>
            option?.label?.toString().toLowerCase().includes(inputValue.toLowerCase())
          }
        >
          <Input name={field.name} placeholder={props.placeholder} status={isError ? 'error' : undefined} />
        </AutoComplete>
      </Form.Item>
    </Hint>
  );
};
